/** @format */

import React, {FC, useCallback, useEffect, useLayoutEffect, useState} from "react";
import {Linking, Platform, ScrollView, StyleSheet, Text, View} from "react-native";
import {Button} from "../../components";
import {ButtonType, IsMobile} from "../../theme";
import {CommonActions, NavigationProp, useNavigation,} from "@react-navigation/native";
import {HomeTabsParams} from "../../navigation/AppStack/HomeTabParams";
import {Storage, Store} from "../../utils/Storage";
import * as Clipboard from 'expo-clipboard';
import {AppTheme, useTheme} from "../../theme/colors";
import PageContainer from "../../components/PageContainer";
import CustomTextInput from "../../components/CustomTextInput";
import SharePreviewModal from "./SharePreviewModal";
import {Analytics} from "aws-amplify";
import {WellBeingRoute} from "../../navigation/AppStack/routes";
import AsyncStorage from "@react-native-async-storage/async-storage";
import useAuth from "../../contexts/Auth/useAuth";
import {ErrorItem, useAppContext} from "../../contexts/AppContext";
import {savePassportToAws} from "../../utils/aws.utils";
import {addErrorEntry, getErrorMessage} from '../../utils/errorFormHandlers';
import {API} from "../../utils/API";
import ShareButton from "../../components/ShareButton";

const ShareScreen: FC = () => {
      const [link, setLink] = useState<string>("");
      const [email, setEmail] = useState<string>("");
      const [password, setPassword] = useState<string>("");
      const navigation = useNavigation<NavigationProp<HomeTabsParams>>();
      const [isPreviewVisible, setIsPreviewVisible] = useState(false);
      const [isPasswordAlertVisibleText, setPasswordAlertVisibilityText] =
        useState("");
      const theme = useTheme();
      const shareScreenStyles = getShareScreenStyles(theme);
      const {user, profileMoods, setProfileMoods} = useAuth();
      const {passportData, setPassportData} = useAuth();
      const {setErrorItems, errorItems, saveStatus, setSaveStatus} = useAppContext();
      const [loading, setLoading] = useState(true);
      const [showLoader, setShowLoader] = useState(false);
      const [shareButtonError, setShareButtonError] = useState<string>("");

      const renderErrorItem = ({item}: { item: ErrorItem }) => (
        <View style={shareScreenStyles.errorItem}>
            <Text style={shareScreenStyles.errorText}>{item.message}</Text>
        </View>
      );

      useLayoutEffect(() => {
          navigation.setOptions({headerShown: false});
      }, [navigation]);


      async function saveAndGetLink() {
          let sharingLink = await Storage.getValue('passport_url');

          setLink(
            () => (sharingLink as string)
          );

          const data = await Storage.getStorage();

          const readyUpdatePassportCall =
            (await AsyncStorage.getItem("readyUpdate")) ?? "";

          const form_changed = await Storage.getValue("form_changed");

          /*          console.log("form_changed:" + form_changed);
                    console.log("saveStatus:" + saveStatus);
                    console.log("data.passport_url:" + data.passport_url);*/

          const datatShouldBeSavedToAWS = form_changed || !saveStatus || !data.passport_url;

          try {
              if (datatShouldBeSavedToAWS) {
                  if (user?.username && user?.token.jwtToken) {
                      console.log("Saving to AWS");
                      const pushedLink = await API.Push(data as Store, user?.username!, user?.token.jwtToken!);
                      sharingLink = pushedLink as string;
                      setLink(
                        () => (pushedLink as string)
                      );
                      await savePassportToAws({
                          username: user.username,
                          jwtToken: user.token.jwtToken,
                          setProfileMoods,
                          setPassportData,
                      });
                  }
              } else {
                  console.log("No need to save " + saveStatus);
              }

              await Storage.setValue("form_changed", false);
              setSaveStatus(true);

          } catch
            (ex) {
              const newErrors = addErrorEntry(errorItems, {
                  key: "global",
                  message: "Sorry, data can't be persisted",
                  tab: "Share"
              });
              setErrorItems(newErrors); // Update the state with new errors
          }

          return sharingLink;
      }

      useEffect(() => {
          (async () => {
              setShowLoader(true);
//              await saveAndGetLink();

              let store = await Storage.getStorage();
              setPassword(() => store.password ?? "");
              setLoading(false);
              setShowLoader(false);
          })();
      }, []);


      const getPreviewLink = () => {
          setIsPreviewVisible(true);
      };

      const getEmailLink = useCallback(async () => {
          const linkShare = await saveAndGetLink();
          const sharepassword = (await Storage.getValue("password")) || "";
          const emailFromStorage =  Platform.OS === "android" ? "changeme@theonespace.co.uk" : "";
          const uniFromStorage = (await Storage.getValue("profile_university")) || "";

          setEmail(emailFromStorage); // Make sure state is updated if not already

          const subject = "OneSpace Passport";
          const body = `
Dear Sir/Madam,

As a trustworthy person, I'm sharing with you passport profile with confidential details.

${linkShare}

Please keep this document in a safe place and use the following password to open it:

${sharepassword}
`;

          const mailtoURL = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
          const gmailURL = `googlegmail://co?to=&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

          try {
              Analytics.record({
                  name: "SharePassport",
                  attributes: {
                      email: emailFromStorage,
                      university: uniFromStorage,
                  },
              });

              if (Platform.OS === "android") {
                  const canOpenGmail = await Linking.canOpenURL(gmailURL);
                  if (canOpenGmail) {
                      console.log("Opening Gmail with:", gmailURL);
                      await Linking.openURL(gmailURL);
                      return;
                  }
              }

              //const canOpenMail = await Linking.canOpenURL(mailtoURL);
              //if (canOpenMail) {
                  console.log("Opening default mail client with:", mailtoURL);
                  await Linking.openURL(mailtoURL);
              //}

              //throw new Error("No mail app available");
          } catch (error: any) {
              console.error("Email error:", error);
              const errMsg = error?.message || "Can't open the mail client";
              setShareButtonError(errMsg);

              const newErrors = addErrorEntry(errorItems, {
                  key: "global",
                  message: errMsg,
                  tab: "Share"
              });
              setErrorItems(newErrors);
          }
      }, [link, email]);

      const getPassword = useCallback(async () => {
          if (password) {
              await Clipboard.setStringAsync(password);
              setPasswordAlertVisibilityText("Password was copied to clipboard");
          } else {
              setPasswordAlertVisibilityText("Password is not generated yet, please generate a new password")
              // showErrorModal(
              // 	"Password is not generated yet, please generate a new password"
              // );
          }
      }, [password]);

      const onClickCancelButton = () =>
        navigation.dispatch(
          CommonActions.reset({routes: [{name: WellBeingRoute}]})
        );


      const onClosePreviewModal = () => {
          setIsPreviewVisible(false);
      };

      const copyLinkToClipboard = useCallback(async () => {
          let currentLink = link;
          if (!currentLink) {
              currentLink = await saveAndGetLink(); // ensure link is generated
          }

          if (currentLink) {
              await Clipboard.setStringAsync(currentLink);
              setPasswordAlertVisibilityText("Link copied to clipboard");
          } else {
              setPasswordAlertVisibilityText("No link available to copy");
          }
      }, [link]);

      if (isPreviewVisible) {
          return (
            <SharePreviewModal
              visible={isPreviewVisible}
              onPressClose={onClosePreviewModal}
            />
          );
      }
      return (
        <>
            {showLoader ? (
              <PageContainer loading></PageContainer>
            ) : (<PageContainer>
                  <View style={shareScreenStyles.viewContainer}>
                      <View style={shareScreenStyles.headerView}>
                          <Text style={shareScreenStyles.headerText}>
                              Your Passport
                          </Text>
                          <Button
                            onPress={onClickCancelButton}
                            title="Cancel"
                            buttonTextStyles={shareScreenStyles.headerButton}
                          />
                      </View>
                      <ScrollView
                        style={{flex: 1}}
                        scrollEventThrottle={1600}
                        showsVerticalScrollIndicator={false}
                        contentContainerStyle={{paddingHorizontal: 10}}
                      >

                          <View style={shareScreenStyles.shareLinkView}>
                              <Text style={shareScreenStyles.textParagraph}>
                                  Get a preview of what you will share by clicking the 'Share Passport' button.
                              </Text>
                              <View style={shareScreenStyles.center}>
                                  <Button
                                    title="Preview"
                                    variant={ButtonType.secondary}
                                    onPress={getPreviewLink}
                                  />
                              </View>
                          </View>
                          {errorItems.length == 0 ?
                            <View style={shareScreenStyles.sharePassportView}>
                                <Text style={shareScreenStyles.textParagraph}>
                                    Click the 'Share Passport' button to open an email pre-filled with the necessary
                                    details for sharing your passport information or 'Copy Passport Link'.
                                </Text>
                                <View>
                                    <View style={shareScreenStyles.center}>
                                        <ShareButton
                                          title="Share Passport"
                                          variant={ButtonType.secondary}
                                          disabled={false}
                                          onShare={getEmailLink}
                                          loading={loading}
                                          setGlobalError={setShareButtonError}
                                        />
                                    </View>
                                </View>
                            </View>
                            : <View style={shareScreenStyles.sharePassportView}>
                                <Text style={shareScreenStyles.errorText}>
                                    The form couldn't be saved due to certain errors. It must be resolved prior to
                                    sharing.
                                    {'\n'}
                                    {getErrorMessage(errorItems, "global")}
                                </Text>
                                <View>
                                    <View style={shareScreenStyles.center}>
                                        <ShareButton
                                          title="Share Passport"
                                          variant={ButtonType.secondary}
                                          disabled={false}
                                          onShare={getEmailLink}
                                          loading={loading}
                                        />
                                    </View>
                                </View>
                            </View>
                          }
                          <View style={shareScreenStyles.sharePasswordView}>
                              <Text style={shareScreenStyles.textParagraph}>
                                  Alternatively, you can copy the passport link and password to share manually instead of using email.
                              </Text>
                              <View style={shareScreenStyles.center}>
                                  <Button
                                    title="Copy Passport Link"
                                    variant={ButtonType.secondary}
                                    onPress={copyLinkToClipboard}
                                  />
                              </View>
                          </View>

                          <View style={shareScreenStyles.sharePasswordView}>
                              <Text style={shareScreenStyles.textParagraph}>
                                  Password to open the passport
                              </Text>
                              <CustomTextInput
                                name="share_password"
                                placeholder="Password"
                                defaultValue={password}
                                fieldStyles={shareScreenStyles.sharePasswordField}
                                editable={false}
                              />
                              <View style={shareScreenStyles.center}>
                                  <Button
                                    title="Copy Password"
                                    variant={ButtonType.secondary}
                                    onPress={getPassword}
                                  />
                              </View>
                              {isPasswordAlertVisibleText !== '' && (
                                <Text
                                  style={shareScreenStyles.errorText}
                                  onLayout={() =>
                                    setTimeout(() => {
                                        setPasswordAlertVisibilityText("");
                                    }, 2000)
                                  }
                                >
                                    {isPasswordAlertVisibleText}
                                </Text>
                              )}
                          </View>
                      </ScrollView>
                  </View>
              </PageContainer>
            )}
        </>
      );
  }
;

export default ShareScreen;

const getShareScreenStyles = (theme: AppTheme) => {
    return StyleSheet.create({
        viewContainer: {
            flex: 1,
            backgroundColor: theme.BACKGROUND,
            paddingTop: 23,
            paddingHorizontal: 15,
        },
        headerView: {
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 15,
            paddingVertical: IsMobile ? 0 : 20,
        },
        headerText: {
            fontSize: 20,
            fontWeight: "600",
            lineHeight: 24,
            letterSpacing: 0.8,
            color: theme.TEXT,
        },
        headerButton: {
            color: theme.PRIMARY,
        },

        shareLinkView: {
            marginTop: 52,
        },

        sharePassportView: {
            marginTop: 60,
            marginBottom: 20,
        },
        sharePassportField: {
            marginBottom: 30,
            backgroundColor: theme.BACKGROUND,
            borderBottomColor: "#ddd",
            borderBottomWidth: 1,
            paddingVertical: 5,
            paddingHorizontal: 0,
        },

        sharePasswordView: {
            marginTop: 60,
            marginBottom: 20,
        },

        sharePasswordField: {
            marginBottom: 30,
            backgroundColor: theme.BACKGROUND,
            borderBottomColor: "#ddd",
            borderBottomWidth: 1,
            paddingVertical: 5,
            paddingHorizontal: 0,
        },

        textParagraph: {
            fontSize: 16,
            fontWeight: "400",
            lineHeight: 24,
            letterSpacing: 0.8,
            marginBottom: 30,
            color: theme.TEXT,
        },
        center: {
            alignItems: "center",
        },
        errorText: {
            fontSize: 16,
            fontWeight: "400",
            lineHeight: 24,
            letterSpacing: 0.8,
            marginBottom: 30,
            color: theme.ERROR,
        },

        errorItem: {}

    });
};
